import React, { useEffect, useState } from "react";
//import { Routes, Route,  } from "react-router-dom";
import { HashRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Home from "./pages/Home";
import ConfirmationPage from './pages/ConfirmationPage';
import ActiveMail from "./pages/ActiveMail";

export default function App() {

  const navigate = useNavigate();

  // 🔥 1. State global user
  const [user, setUser] = useState(null);

  // 🔥 2. Charger un user déjà connecté (localStorage)
  useEffect(() => {
    const saved = localStorage.getItem("userData");
    if (saved) {
      setUser(JSON.parse(saved));
    }
  }, []);

  // 🔥 3. Fonction passée au Login
  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  // 🔥 4. Timeout d'inactivité : 20 minutes
  useEffect(() => {
    let timeoutId;

    const resetTimer = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        // Déconnexion automatique
        localStorage.removeItem("userData");
        setUser(null);
        navigate("/login");
      }, 20 * 60 * 1000); // 20 minutes
    };

    // Événements qui comptent comme activité
    const activityEvents = [
      "mousemove",
      "keydown",
      "click",
      "scroll",
      "touchstart"
    ];

    activityEvents.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    // Démarrer le timer au montage
    resetTimer();

    // Clean-up
    return () => {
      clearTimeout(timeoutId);
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
      <Route path="/register" element={<Register />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/home" element={<Home user={user} />} />
      <Route path="/" element={<Home user={user} />} />
      <Route path="/confirmation" element={<ConfirmationPage />} />
      <Route path="/activemail" element={<ActiveMail />} />
    </Routes>
  );
}
